// Client instrumentation — no-op without Sentry.
// To re-enable: install @sentry/nextjs, set NEXT_PUBLIC_SENTRY_DSN
